import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=ccbc56da&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Index.vue?vue&type=style&index=1&id=ccbc56da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbc56da",
  null
  
)

export default component.exports